import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { borders } from 'styled-system';
import { Box, Flex, Divider } from 'rebass';
import { FONT_SIZE, SPACE } from '@tcaster/tcaster-theme';

import { Text, SplitScore, SplitText } from '../../../../../Components/Base';
import ScoreBar from '../../../../../Components/ScoreBar';

const FlexBorder = styled(Flex)`
  ${borders};
`;

const ExamResultPanel = ({ title, score, fullScore, averageScore, scoreVariant }) => {
  return (
    <Box>
      <Text.Title pb={SPACE.medium}>{title}</Text.Title>
      <FlexBorder borderColor="borderGrey" border={1} flexDirection="column">
        <Flex flexDirection="column" alignItems="center" p={SPACE.small}>
          <SplitText
            left="คะแนนที่ได้"
            right="คะแนนเต็ม"
            fontSize={FONT_SIZE.semilarge}
            fontWeight="bold"
          />
          <SplitScore score={score} fullScore={fullScore} fontSize={36} variant={scoreVariant} />
        </Flex>
        <Divider width={1} borderColor="borderGrey" my={0} />
        <Box bg="gridGrey" px="10%" py={SPACE.small}>
          <ScoreBar
            score={score}
            fullScore={fullScore}
            averageScore={averageScore}
            variant="full"
            backgroundColor="borderGrey"
            scoreVariant={scoreVariant}
          />
        </Box>
      </FlexBorder>
    </Box>
  );
};

export default ExamResultPanel;

ExamResultPanel.propTypes = {
  title: PropTypes.string,
  score: PropTypes.number,
  fullScore: PropTypes.number,
  averageScore: PropTypes.number,
};
